<template>
    <button
        type="button"
        class="border border-gray-400 hover:border-gray-500 text-gray-500 hover:text-gray-600 bg-white hover:bg-gray-100 uppercase font-semibold tracking-wider leading-normal"
        :class="[size_classes, { 'cursor-pointer': !disabled, 'cursor-not-allowed opacity-50': disabled }]"
        :disabled="disabled"
        @click.stop="$emit('click')"
    >
        <slot />
    </button>
</template>

<script>
export default {
    props: {
        size: { default: 'normal'},
        disabled: { default: false },
    },

    computed: {
        size_classes() {
            return {
                'normal': 'text-xs px-6 py-3',
                'small': 'text-2xs px-5 py-2',
                'x-small': 'text-2xs px-4 py-1',
            }[ this.size ];
        },
    },
}
</script>
